<template>
  <input-wrapper
    :error="error"
    :helperText="helperText"
    :disabled="disabled"
    :class="Object.assign({'styled-select': 1}, classList)">

    <select
      ref="select"
      v-model="currentValue"
      @focus="focus"
      @blur="blur"
      :disabled="disabled"
      :id="id">

      <option value=""></option>

      <slot></slot>
    </select>

    <input-label :isRequired="isRequired" :for-id="id">{{placeholder}}</input-label>

    <sprite class="arrow" name="arrow_drop_down" />

  </input-wrapper>
</template>

<script>
  import input from '../../../mixins/input'
  import InputWrapper from '../../../components/ui/inputs/InputWrapper.vue'
  import InputLabel from '../../../components/ui/inputs/InputLabel.vue'
  import Sprite from '../../../components/ui/Sprite.vue'

  export default {
    name: 'styled-select',

    mixins: [input],

    props: {
      disabled: {
        type: Boolean,
        default: false
      },

      isRequired: {
        type: Boolean,
        default: false
      }
    },

    components: {
      InputLabel,
      InputWrapper,
      Sprite
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  .styled-select
    position: relative

    label
      pointer-events: none

    &.has-value
      .input-label
        transform: translateY(-21px) scale(0.75)

      select
        color: $color-text

    &.has-focus
      .input-label
        transform: translateY(0) scale(1)

      &.has-value
        .input-label
          transform: translateY(-21px) scale(0.75)

      .arrow
        fill: $color-text

    select
      height: 46px
      border: none
      box-shadow: none
      background: transparent
      background-image: none
      -webkit-appearance: none
      -moz-appearance: none
      font-size: $font-size-input
      width: 100%
      cursor: pointer
      transition: color $transition-duration $transition-easing

      *
        color: $color-text

      &:-moz-focusring
        color: transparent
        text-shadow: none

      &:focus
        outline: none
        color: $color-text-light

    .arrow
      width: 20px
      height: 20px
      position: absolute
      right: 0
      top: 28px
      pointer-events: none
      cursor: pointer
      transition: fill $transition-duration $transition-easing
      fill: $color-icon-disabled
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/StyledSelect.vue